import React from 'react';
import { clients } from '../data/portfolioData';
import { FaBuilding } from 'react-icons/fa';
import Icon from './Icon';
import useScrollReveal from '../hooks/useScrollReveal';
import './Clients.css';

const Clients: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="clients" className="section clients-section" ref={ref}>
      <div className={`container ${isVisible ? 'revealed' : 'hidden-section'}`}>
        <h2 className="section-title">Clienti & Progetti</h2>
        <p className="section-subtitle">
          Le collaborazioni saranno pubblicate dopo aver confermato quali aziende e informazioni possono essere rese pubbliche.
        </p>
        {clients.length === 0 ? (
          <p className="section-subtitle">Sezione in preparazione.</p>
        ) : (
          <div className="clients-grid">
            {clients.map((client, index) => (
              <div key={client.id} className="client-card animate-fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="client-icon">
                  {client.logo ? <img src={client.logo} alt={`${client.name} logo`} className="client-logo" /> : <Icon icon={client.icon || FaBuilding} />}
                </div>
                <h3 className="client-name">{client.name}</h3>
                <span className="client-sector">{client.sector}</span>
                <p className="client-description">{client.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Clients;
